import {Component, Input, ViewChild} from '@angular/core';
import {BaseResultComponent} from '../base-result/base-result.component';
import {Util} from '../../../util/util';
import {Asset} from '../../../class/asset';
import {AssetResult} from '../../../class/result/asset-result';
import {WelfarePipeChartComponent} from '../charts/welfare-pipe-chart/welfare-pipe-chart.component';
import {NbWindowService} from '@nebular/theme';

@Component({
  selector: 'app-asset-result',
  templateUrl: './asset-result.component.html',
  styleUrls: ['./asset-result.component.css']
})
export class AssetResultComponent extends BaseResultComponent {

  @Input()
  assetResult: AssetResult;

  @ViewChild('assetStatusChart')
  assetStatusChart: WelfarePipeChartComponent;

  @Input()
  hideGraph = false;

  constructor(windowService: NbWindowService) {
    super(windowService);
  }

  isHomeAsset(asset: Asset): boolean {
    return Util.isHomeAsset(asset);
  }

  isOtherAsset(asset: Asset): boolean {
    return Util.isOtherAsset(asset);
  }

  isGeneralAsset(asset: Asset): boolean {
    return Util.isGeneralAsset(asset);
  }

  onResultImpl() {
    if (this.assetStatusChart) {
      this.assetStatusChart.onResultImpl();
    }
  }

  isOtherAssetPresent() {
    let ret = false;

    for (const asset of this.assetResult.assets) {
      if (asset) {

        // check if asset is other asset
        ret = this.isOtherAsset(asset);

        if (ret) {
          break;
        }
      }
    }

    return ret;
  }

  ngOnInitImpl() {
  }
}
